// extracted by mini-css-extract-plugin
module.exports = {"container":"TitlePanel_container__2MfBC","co":"TitlePanel_co__1j4m7","header":"TitlePanel_header__jNUc6"};